/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".btn-blue[_ngcontent-%COMP%]{color:#fff;background-color:#1b76bb}.btn[_ngcontent-%COMP%]{font-weight:500;font-size:16px;border-radius:25px;padding:8px 24px;border:none}.btn-success2[_ngcontent-%COMP%]{background-color:#2ecc71;color:#fff}.btn-success2[_ngcontent-%COMP%]:hover{background-color:#27ae60}"];
export { styles as styles };
